'use strict';
angular.module('aides').constant('ShareConstants', {
  DEMANDEUR_EMAIL: 'DEMANDEUR_EMAIL',
  ALREADY_ADDED: 'ALREADY_ADDED',
  BAD_FORMATTED: 'BAD_FORMATTED',
  TOO_LONG: 'TOO_LONG',
});
